import * as React from "react";
import { SVGProps } from "react";
const SvgTrustAndEstatePlan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M6.91 17.727v-5.966l-1.146.875L5 11.618l1.91-1.463V8.181h1.272v1.002L12 6.273l7 5.345-.764 1.002-1.145-.859v5.966H6.909Zm1.272-1.273h3.182V13.91h1.272v2.545h3.182v-5.663L12 7.88l-3.818 2.91v5.665ZM6.909 7.545c0-.53.186-.98.557-1.352a1.841 1.841 0 0 1 1.352-.557c.18 0 .332-.06.454-.183A.615.615 0 0 0 9.455 5h1.272c0 .53-.185.981-.556 1.352a1.841 1.841 0 0 1-1.353.557c-.18 0-.331.061-.454.183a.617.617 0 0 0-.182.453H6.909Z"
      fill="#fff"
    />
  </svg>
);
export default SvgTrustAndEstatePlan;
